export const ElementData = {
    id: "",
    name: "",
    description: "",
    firstname: "",
    lastname: "",
    middlename: "",
    company: "",
    position: "",
    nodetype: "",
    nodeshape: "circle",
    image: "",
    edgetype: "",
    createdon: new Date('1995-12-17T03:24:00'),
}